import { FC, memo, useMemo } from 'react'
import styled from 'styled-components'

import { FlexDivCentered } from 'components/layout/flex'
import { useAppSelector } from 'state/hooks'
import { selectTokens } from 'state/exchange/selectors'

export type TokenIconProps = {
	currencyKey: string
	type?: 'synth' | 'asset' | 'token'
	className?: string
	width?: number
	height?: number
	isDeprecated?: boolean
	style?: any
	url?: string
}

const TokenIcon: FC<TokenIconProps> = memo(({ currencyKey, isDeprecated, ...props }) => {
	const tokensMap = useAppSelector(selectTokens)

	const tokenInfo = useMemo(()=>{
		return tokensMap.filter(e=>e.address==currencyKey)[0]
	}, [tokensMap, currencyKey])

	if (!!tokenInfo) {
		return (
			<TokenImage src={tokenInfo.logo} $isDeprecated={isDeprecated} {...props} />
		)
	} else {
		return (
			<Placeholder $isDeprecated={isDeprecated} {...props}>
				{currencyKey}
			</Placeholder>
		)
	}
})

const TokenImage = styled.img<{ $isDeprecated?: boolean }>`
	border-radius: 100%;
	border: 2px solid ${(props) => (props.$isDeprecated ? props.theme.colors.red : 'transparent')};
`

const Placeholder = styled(FlexDivCentered)<{
	$isDeprecated?: boolean
	height?: string | number
	width?: string | number
}>`
	border-radius: 100%;
	color: ${(props) => props.theme.colors.selectedTheme.button.text.primary};
	border: 2px solid
		${(props) =>
			props.$isDeprecated
				? props.theme.colors.red
				: props.theme.colors.selectedTheme.button.text.primary};
	font-size: 7px;
	font-family: ${(props) => props.theme.fonts.bold};
	justify-content: center;
	margin: 0 auto;
	height: ${(props) => props.height}px;
	width: ${(props) => props.width}px;
`

export default TokenIcon
